"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _idGenerator = _interopRequireDefault(require("../../../utils/idGenerator"));

var _LabeledInput = _interopRequireDefault(require("../LabeledInput"));

var _Select = _interopRequireDefault(require("../Select"));

var _SelectWithInput = require("./SelectWithInput.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This component adds a labeled input that will appear when 'Other' is selected
 * within the Select options.
 *
 * This is primarily a shorthand to keep from having to rewrite the logic for this
 * behavior in the frontend apps, and as such includes no additional styling (except for
 * minor _inStyleGuide styling).
 *
 * NOTE: Since the errors on LabeledInput are not controlled by the parent, but the errors
 * on the Select are, the user needs to listen for and update the error object for only
 * the Select
 */
var SelectWithInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SelectWithInput, _React$PureComponent);

  var _super = _createSuper(SelectWithInput);

  function SelectWithInput(props) {
    var _this;

    _classCallCheck(this, SelectWithInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleHoistErrors", function (errors) {
      return _this.props.hoistErrors && _this.props.hoistErrors(errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputBlur", function (e, errors) {
      return _this.props.onInputBlur && _this.props.onInputBlur(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e, errors) {
      return _this.props.onInputChange && _this.props.onInputChange(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputFocus", function (e, errors) {
      return _this.props.onInputFocus && _this.props.onInputFocus(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectBlur", function (e) {
      return _this.props.onSelectBlur && _this.props.onSelectBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectChange", function (e) {
      return _this.props.onSelectChange && _this.props.onSelectChange(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectFocus", function (e) {
      return _this.props.onSelectFocus && _this.props.onSelectFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      var selectErrors = (0, _lodash.castArray)(_this.selectRef.current.validateInput());
      var inputErrors = _this.inputRef.current ? (0, _lodash.castArray)(_this.inputRef.current.validateInput()) : [];
      return [].concat(_toConsumableArray(selectErrors), _toConsumableArray(inputErrors));
    });

    _this.selectRef = _react.default.createRef();
    _this.inputRef = _react.default.createRef();
    _this.componentId = (0, _idGenerator.default)();
    return _this;
  }

  _createClass(SelectWithInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _inStyleGuide = _this$props._inStyleGuide,
          dataTestId = _this$props.dataTestId,
          inputLabel = _this$props.inputLabel,
          inputName = _this$props.inputName,
          inputValidationRules = _this$props.inputValidationRules,
          inputValue = _this$props.inputValue,
          selectOptions = _this$props.selectOptions,
          selectErrors = _this$props.selectErrors,
          selectLabel = _this$props.selectLabel,
          selectedOption = _this$props.selectedOption,
          selectName = _this$props.selectName,
          selectValidationRules = _this$props.selectValidationRules;
      return /*#__PURE__*/_react.default.createElement(_SelectWithInput.StyledSelectWithInputWrapper, {
        dataTestId: dataTestId,
        _inStyleGuide: _inStyleGuide
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        ref: this.selectRef,
        options: [].concat(_toConsumableArray(selectOptions), [{
          value: 'other',
          label: 'Other'
        }]),
        dataTestId: "select-select",
        name: selectName,
        errors: selectErrors,
        hoistErrors: this.handleHoistErrors,
        label: selectLabel,
        onChange: this.handleSelectChange,
        onBlur: this.handleSelectBlur,
        onFocus: this.handleSelectFocus,
        selectedOption: selectedOption,
        validationRules: selectValidationRules
      }), selectedOption && selectedOption.value === 'other' && /*#__PURE__*/_react.default.createElement(_LabeledInput.default, {
        autoFocus: true,
        dataTestId: "select-input",
        id: "select-input-".concat(this.componentId),
        label: inputLabel,
        name: inputName,
        onChange: this.handleInputChange,
        onBlur: this.handleInputBlur,
        onFocus: this.handleInputFocus,
        value: inputValue,
        validationRules: inputValidationRules
      }));
    }
  }]);

  return SelectWithInput;
}(_react.default.PureComponent);

_defineProperty(SelectWithInput, "propTypes", {
  /** Hook for styleguide styles */
  _inStyleGuide: _propTypes.default.bool,

  /** Testing Hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Hoists errors to the parent */
  hoistErrors: _propTypes.default.func.isRequired,

  /** Label for the optional LabeledInput */
  inputLabel: _propTypes.default.string,

  /** Name for the optional LabeledInput */
  inputName: _propTypes.default.string.isRequired,

  /** Validation rules for the optional LabeledInput */
  inputValidationRules: _propTypes.default.shape({}),

  /** Value for the optional LabeledInput */
  inputValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Blur handler for the optional LabeledInput */
  onInputBlur: _propTypes.default.func,

  /** Change handler for the optional LabeledInput */
  onInputChange: _propTypes.default.func.isRequired,

  /** Focus handler for the optional LabeledInput */
  onInputFocus: _propTypes.default.func,

  /** Blur handler for the Select */
  onSelectBlur: _propTypes.default.func,

  /** Change handler for the Select */
  onSelectChange: _propTypes.default.func.isRequired,

  /** Focus handler for the Select */
  onSelectFocus: _propTypes.default.func,

  /** List of options for the Select ('Other' is added automatically) */
  selectOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  })).isRequired,

  /** List of errors for the Select */
  selectErrors: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Label for the Select */
  selectLabel: _propTypes.default.string,

  /** Name for the Select (Required for validation) */
  selectName: _propTypes.default.string.isRequired,

  /** Selected Option for the Select */
  selectedOption: _propTypes.default.oneOfType([_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string
  }), _propTypes.default.string]),

  /** Validation rules for the Select */
  selectValidationRules: _propTypes.default.shape({})
});

_defineProperty(SelectWithInput, "defaultProps", {
  _inStyleGuide: false,
  inputLabel: undefined,
  inputValidationRules: {},
  onInputBlur: undefined,
  onInputFocus: undefined,
  onSelectBlur: undefined,
  onSelectFocus: undefined,
  selectErrors: [],
  selectLabel: undefined,
  selectedOption: undefined,
  selectValidationRules: {}
});

var _default = SelectWithInput;
exports.default = _default;